<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script>
// import { RouterView } from "vue-router";
export default {
  name: "App",
  data(){
    return {
      // current:''
    }
  },
};
</script>

<style>
@import '@/assets/css/base.css';
</style>
